<template>
  <v-container fluid class="custom-container">
    <v-layout
      class="list-folders-actions"
      justify-center
      v-if="!isEmpty(groupedFolders)"
    >
      <v-flex xs4>
        <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount}}</span>
        <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <section class="folders">
      <v-layout
        class="folder-list"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <span
          class="subheading grey--text my-3 text-capitalize"
        > {{ index }}</span>

        <div class="elevation-1 group" v-if="group.length > 0">
          <draggable :options="{ delay: dragDelay }">
            <transition-group
              name="fade-cascade"
              tag="div"
              class="cascade-group"
              appear
            >
              <v-layout
                class="item"
                v-for="(folder, folderIndex) in group"
                :key="`${folder.id}-${folderIndex}`"
                @click.stop="openFolder(folder.id)"
                justify-center
                align-center
                row
                wrap
                @dragstart="startDrag(folder.id)"
                @dragend="setDraggingItem(null)"
                @mousedown="startTimer(folder.id)"
                @mouseup="stopTimer"
                @mouseleave="stopTimer"
                :class="{ 'dragging': folder.id === draggingItemId }"
                :style="{ '--cascade-delay': `${folderIndex * 0.05}s` }"
              >
                <v-flex class="pa-2" xs4>
                  <v-layout class="folder-name" align-center row>
                    <img
                      class="d-flex mx-3 folder-icon"
                      src="/static/images/folder/folder-closed-icon.svg"
                      alt="Ícone de Pasta"
                    >
                    <v-layout column>
                      <v-flex class="grey--text">
                        <span class="caption process-number">{{ folder.process_number }}</span>
                      </v-flex>
                      <v-flex class="type-name">
                        <span>{{ folder.folder_type.name }}</span>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>

                <v-flex class="pa-2" xs3 xl4>
                  <v-chip color="grey-lighten-2 entity-chip">
                    <v-avatar size="16" color="white">
                      <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                    </v-avatar>
                    <strong class="grey--text text--darken-2 text-truncate">{{ folder.entity.name }}</strong>
                  </v-chip>
                </v-flex>

                <v-flex class="pa-2" xs3 xl2>
                  <v-list class="user-card pa-0" v-if="folder.current_owner">
                    <v-list-tile avatar>
                      <v-list-tile-avatar color="grey" size="24">
                        <img
                          alt="Avatar"
                          :src="folder.current_owner.avatar.url"
                          v-if="folder.current_owner.avatar.url"
                        >
                        <span class="caption" v-else>{{ acronym(folder.current_owner.name) }}</span>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title class="body-1">{{ shortName(folder.current_owner.name) }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="caption"
                          v-if="folder.current_owner.role"
                        >{{ folder.current_owner.role.name }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>

                <v-flex class="pa-2" xs2 >
                  <v-layout align-center>
                    <v-icon v-if="folder.last_transaction" size="22" class="mr-2">mdi-clock-fast</v-icon>
                    <span v-if="folder.last_transaction" class="caption">
                      {{ formatDate(folder.last_transaction.created_at) || 'Sem data de arquivação' }}
                    </span>
                    <span v-else class="caption">
                        Sem data de arquivação
                    </span>
                  </v-layout>
                </v-flex>

                <span class="folder-border"></span>
              </v-layout>
            </transition-group>
          </draggable>
        </div>
      </v-layout>
    </section>
  </v-container>
</template>


<script>
import { capitalize, isEmpty, lowerCase, startCase, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import draggable from "vuedraggable";

export default {
  name: "archived",
  components: {
    draggable
  },
  mounted() {
    // Usamos o watcher pageNumber ao invés de chamar getFolders() diretamente
    // O watcher tem a prop immediate: true, então é chamado automáticamente

    // Adiciona listener para o evento de mudança de unidade administrativa
    window.addEventListener('admin-unit-changed', this.handleAdminUnitChange);
  },

  beforeDestroy() {
    // Remove o event listener ao destruir o componente
    window.removeEventListener('admin-unit-changed', this.handleAdminUnitChange);
  },
  data() {
    return {
      firstRender: true,
      truncateText: truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500,
      isLoadingFolders: false  // Flag para controlar requisições simultâneas
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    // Handler para mudança de unidade administrativa
    handleAdminUnitChange() {
      this.pageNumber = 1;
      // Também forçamos a atualização da contagem de pastas
      setTimeout(() => {
        this.$store.dispatch('getFoldersCount', { forceUpdate: true });
      }, 500);
      // Não precisamos chamar getFolders() aqui, pois a mudança no pageNumber já dispara o watcher
    },

    getFolders() {
      // Evita requisições simultâneas
      if (this.isLoadingFolders) {
        console.log('Requisição já em andamento. Ignorando nova requisição de getFolders.')
        return;
      }

      this.isLoadingFolders = true;
      this.$store.dispatch("toggleLoader", { show: true });

      // Verifica se a unidade administrativa foi definida
      if (!this.selectedAdministrativeUnit) {
        console.warn('Unidade administrativa não definida, usando a principal');
        const AdminUnitSwitchService = require('@/services/AdminUnitSwitchService').default;
        AdminUnitSwitchService.ensureSelectedUnit();
      }

      this.$store
        .dispatch("getFoldersArchived", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          searchText: this.searchText || "",
          administrativeUnitId: this.selectedAdministrativeUnit || ""
        })
        .catch(error => {
          console.error("Erro ao carregar pastas arquivadas:", error);
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
          this.isLoadingFolders = false;
        });
      // Não precisamos carregar a contagem aqui, pois já é feito pelo FoldersLayout
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    capitalizeText(string) {
      return capitalize(lowerCase(string));
    },
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    resetFolders() {
      this.pageNumber = 1;
      this.$store.dispatch("getFoldersArchive");
    },
    orderDateToString(folder) {
      switch (this.orderFilter.property) {
        case "updated_at":
          // Usar o sort_updated_at que vem do backend
          const date = folder.sort_updated_at || folder.updated_at;
          return this.formatMonthYear(date);
        default:
          return folder.last_transaction == null
            ? "Sem data"
            : this.formatMonthYear(folder.last_transaction.created_at);
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    selectedAdministrativeUnit() {
      return this.$store.getters.selectedAdministrativeUnit;
    },
    loading() {
      return this.$store.getters.loading;
    },
    folders() {
      return this.$store.getters.folders;
    },
    foldersArchived() {
      if (this.$store.getters.folders.length === undefined) {
        return [];
      }

      const archiveds = this.$store.getters.folders.filter(
        item => item.folder_section === "archived"
      );
      return archiveds;
    },
    groupedFolders() {
      const group = {};
      const orderedKeys = [];

      this.foldersArchived.forEach(folder => {
        const date = folder.last_transaction && folder.last_transaction.updated_at
          ? new Date(folder.last_transaction.updated_at)
          : (folder.updated_at ? new Date(folder.updated_at) : null);
        const key = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}` : 'Sem data';
        if (!group[key]) {
          group[key] = { folders: [folder], date: date };
          orderedKeys.push(key);
        } else {
          group[key].folders.push(folder);
        }
      });

      orderedKeys.sort((a, b) => {
        if (group[a].date && group[b].date) {
          return this.orderFilter.order === 'asc'
            ? group[a].date - group[b].date
            : group[b].date - group[a].date;
        }
        return 0;
      });

      const orderedGroups = {};
      orderedKeys.forEach(key => {
        const label = group[key].date
          ? this.formatMonthYear(group[key].date)
          : 'Sem data';
        orderedGroups[label] = group[key].folders;
      });

      return orderedGroups;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.folder-list {
  &:last-child {
    margin-bottom: 75px;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 45px !important;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
}

.dragging {
  background-color: #005ece;
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}
.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}
.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/archived/Archived.vue